// extracted by css-extract-rspack-plugin
module.exports =  {"other_calc_container":"RlGWO","other_calc_wrap":"FHFnA","card_container":"PcP9O","calculator_card":"N1rr5"};